/**
 * Location Helper Utility
 * Simple helpers for country-state-city data
 */
import { State, City } from "country-state-city";

/**
 * Clean location names - removes problematic Unicode characters
 */
export const cleanLocationName = (name) => {
  if (!name) return "";
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\u0000-\u001F\u007F-\u009F]/g, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/[^\p{L}\p{N}\s\-'.,()]/gu, "")
    .replace(/\s+/g, " ")
    .trim();
};

/**
 * Get cleaned states for a country
 */
export const getCleanedStates = (countryCode) => {
  if (!countryCode) return [];

  const rawStates = State.getStatesOfCountry(countryCode);
  return rawStates
    .map((state) => ({
      ...state,
      name: cleanLocationName(state.name),
    }))
    .filter((state) => state.name)
    .filter(
      (state, index, self) =>
        index === self.findIndex((s) => s.name === state.name)
    );
};

/**
 * Get cleaned cities for a state
 */
export const getCleanedCities = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return [];

  const rawCities = City.getCitiesOfState(countryCode, stateCode);
  return rawCities
    .map((city) => ({
      ...city,
      name: cleanLocationName(city.name),
    }))
    .filter((city) => city.name)
    .filter(
      (city, index, self) =>
        index === self.findIndex((c) => c.name === city.name)
    );
};
